import script from "./myUpload.vue?vue&type=script&lang=ts&setup=true"
export * from "./myUpload.vue?vue&type=script&lang=ts&setup=true"

import "./myUpload.vue?vue&type=style&index=0&id=be22965a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-be22965a"]])

export default __exports__